import React from 'react'

import Action from '../Action'

const InlineLink: React.FC<any> = (props) => (
  <Action uiComponent="CTALink" Tag="a" inline {...props} />
)

export default InlineLink
